import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
@Component({
  selector: 'app-bar-chart-inactive-sex',
  templateUrl: './bar-chart-inactive-sex.component.html',
  styleUrls: ['./bar-chart-inactive-sex.component.css']
})
export class BarChartInactiveSexComponent implements OnInit {

          // per inizializzazione
          getAuthState: Observable<any>;
          getDoctorState: Observable<any>;
          isAuthenticated: boolean;
          user = null;
          errorMessage = null;
          subscription1: Subscription;
          subscription2: Subscription;
          subscription3: Subscription;
          subscription4: Subscription;
          subscription5: Subscription;

          title = "Sesso";
          destination = 'inactive';
          // elementi che servono per il bar-chart
          canvas: any;
          ctx: any;
          myChartInactivePatients: Chart;
    
          // ******************************************************************************************************************
          // seguenti righe: inizializzazione dei pazienti 
          // ******************************************************************************************************************
          inactiveGlobalUomo = 0;
          inactiveGlobalDonna = 0;
          inactiveGlobalAltroSesso = 0;
  
    
          activeGlobalUomo = 0;
          activeGlobalDonna = 0;
          activeGlobalAltroSesso = 0;
  
    
    
          UomoGlobalPatients = 0;
          DonnaGlobalPatients = 0;
          AltroSessoGlobalPatients = 0;
  
   
    
          inactiveGlobalPatientsArray = [];
          activeGlobalPatientsArray = [];
          inactivePatientsGlobal = [];
          // ******************************************************************************************************************
          // bar chart dei pazienti 
          // ******************************************************************************************************************
          public barChartLabelsGlobalInactive = ['UOMO', 'DONNA','NON SPECIFICATO'];
          public barChartTypeGlobalInactive = 'horizontalBar';
          public barChartLegendGlobalInactive = true;
          public barChartDataGlobalInactive = [
            {
              data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal','teal'],
              hoverBackgroundColor: ['#066', '#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
            },
            {
              data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered', 'orangered','orangered'],
              hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
            }];
          
    
    
          // constructor
          constructor(private store: Store<AppState>,
                      private doctorService: DoctorService,
                      private snackBar: MatSnackBar) {
            this.getAuthState = this.store.select(selectAuthState);
            this.getDoctorState = this.store.select(selectDoctorState);
          }
          // ******************************************************************************************************************
          // metodo all'inizio
          ngOnInit(): void {
            this.subscription4 = this.getAuthState.subscribe((state) => {
              this.isAuthenticated = state.isAuthenticated;
              this.user = JSON.parse(localStorage.getItem('user'));
              this.errorMessage = state.errorMessage;
              this.retrieveGlobalInactiveUomo();
            });
          }
          ngOnDestroy(): void {
            this.subscription1.unsubscribe();
            this.subscription2.unsubscribe();
            this.subscription3.unsubscribe();
            this.subscription4.unsubscribe();
            this.subscription5.unsubscribe();
  
          }
          // ******************************************************************************************************************
          // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
          // e in standard e poi tutti
          // i pazienti in ogni categoria per poter calcolare gli attivi
          // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
  
          retrieveGlobalInactiveUomo() {
            this.subscription1 = this.doctorService.getInactiveUomoNumber().subscribe(npatients => {
              this.inactiveGlobalUomo = parseInt(npatients.toString());
              this.inactiveGlobalPatientsArray.push(this.inactiveGlobalUomo); // riempio il vettore del bar chart con standard
              this.retrieveGlobalInactiveDonna();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
          retrieveGlobalInactiveDonna() {
            this.subscription2 = this.doctorService.getInactiveDonnaNumber().subscribe(npatients => {
              this.inactiveGlobalDonna = parseInt(npatients.toString());
              this.inactiveGlobalPatientsArray.push(this.inactiveGlobalDonna); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalInactiveAltroSesso();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
  
          retrieveGlobalInactiveAltroSesso() {
            this.subscription5 = this.doctorService.getInactiveNoSexNumber().subscribe(npatients => {
              this.inactiveGlobalAltroSesso = parseInt(npatients.toString());
              this.inactiveGlobalPatientsArray.push(this.inactiveGlobalAltroSesso); // riempio vettore del bar-chart con telemedicina
              this.retrieveGlobalUomoDonnaAltro();
  
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
        
          retrieveGlobalUomoDonnaAltro() {
            this.subscription3 = this.doctorService.getGlobalUOMODOONNAALTROLoginExistsNumber().subscribe(num => {
              this.UomoGlobalPatients = num[0];
              this.DonnaGlobalPatients = num[1];
              this.AltroSessoGlobalPatients = num[2];
              this.activeGlobalUomo = this.UomoGlobalPatients - this.inactiveGlobalUomo;
              this.activeGlobalPatientsArray.push(this.activeGlobalUomo); // riempio il vettore del bar chart con standard           
              this.activeGlobalDonna = this.DonnaGlobalPatients - this.inactiveGlobalDonna;
              this.activeGlobalPatientsArray.push(this.activeGlobalDonna); // riempio il vettore del bar chart con telemedicina
              this.activeGlobalAltroSesso = this.AltroSessoGlobalPatients - this.inactiveGlobalAltroSesso;
              this.activeGlobalPatientsArray.push(this.activeGlobalAltroSesso); // riempio il vettore del bar chart con standard           
              this.canvasSetting();
            }, error => {
              if (error.status === 500) {
                localStorage.setItem('expirationTime', '0');
                console.log('SESSIONE SCADUTA');
                location.reload();
              }
            });
          }
         
          canvasSetting() {
              this.canvas = document.getElementById('myChartInactiveSex') as HTMLCanvasElement;
              this.ctx = this.canvas.getContext('2d');
              this.myChartInactivePatients = new Chart(this.ctx, {
                type: this.barChartTypeGlobalInactive,
                data: {
                  labels: this.barChartLabelsGlobalInactive,
                  datasets: this.barChartDataGlobalInactive,
                },
                options: {
                  maintainAspectRatio: true,
                  responsive: true,
    
                  scales: {
                    xAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                    yAxes: [{
                      display: true,
                      stacked: false,
                      ticks: {
                        fontSize: 12,
                        fontStyle: 'bold',
                        fontFamily: 'Helvetica',
                        fontColor: '#006192'
                      }
                    }],
                  },
                  legend: {
                   
                    display: true,
                    position: 'top',
                    labels: {
                      usePointStyle: true,
                      fontColor: '#006192',
                      fontSize: 18,
                      fontFamily: 'Helvetica',
                    }
                  },
                  tooltips: {
                    // content: '{pathology}: {number}',
                    backgroundColor: '#1c1c1c',
                    bodyFontSize: 18,
                    titleFontSize: 18,
                    cornerRadius: 5,
                    caretPadding: 10
                  },
                  title: {
                    display: true,
                    text: "N° di utenti attivi/inattivi",
                    fontColor: '#006192',
                    fontSize: 20,
                    fontFamily: 'Helvetica',
                  },
                  hover: {
                    mode: 'nearest',
                    intersect: true
                  }
                }
              });
              } // dopo aver ottenuto tutti i dati creo il bar chart
          
        }
        